import * as Cookies from "js-cookie";
import * as React from "react";

export const usePlatform = () => {
  return React.useMemo(() => {
    const clientPlatform = Cookies.get("platform");
    return {
      isMobilePlatform: ["android", "ios"].indexOf(clientPlatform || "") > -1,
    };
  }, []);
};
